module.exports = __webpack_public_path__ + "static/media/trophy-alt.7cf2435e.svg";